// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import camelCase from "lodash/camelCase";

export function objectKeysToCamelCase(obj: Dictionary<any>): any {
    if (Array.isArray(obj)) {
        return obj.map(v => objectKeysToCamelCase(v));
    }
    if (obj != null && obj.constructor === Object) {
        return Object.keys(obj).reduce(
            (result, key) => ({
                ...result,
                [camelCase(key)]: objectKeysToCamelCase(obj[key]),
            }),
            {},
        );
    }

    return obj;
}
